module.exports = __webpack_public_path__ + "img/emoji_90.40f4a6ba.png";